import {
  IOfferingSearchFilterEnum,
  IOfferingSearchInput,
} from '@r-client/data/graphql-types';

import { ISortByValue } from '../components/growth-stage-ventures/sort-by-menu/types';
import { toOfferingSearchSort } from './to-offering-search-sort';

export interface IBuildGrowthStageSearchParamsArgs {
  /** Selected sector slug, or `null` for the "All" chip. */
  sectorSlug: string | null;
  sort: ISortByValue;
}

/**
 * `tags` is omitted rather than sent as `[]` when no sector is selected: an
 * empty list is a filter matching nothing on some backends, whereas omitting
 * the key is unambiguous "no sector filter". The spread keeps it out of the
 * object entirely rather than setting it to `undefined`.
 */
export const buildGrowthStageSearchParams = ({
  sectorSlug,
  sort,
}: IBuildGrowthStageSearchParamsArgs): IOfferingSearchInput => ({
  filter: IOfferingSearchFilterEnum.Live,
  sort: toOfferingSearchSort(sort),
  ...(sectorSlug ? { tags: [sectorSlug] } : {}),
});
